// extracted by mini-css-extract-plugin
export default {"text":"QuizzItem_text__fX0tS","quizzItem":"QuizzItem_quizzItem__y60eO","image":"QuizzItem_image__rczBF","question":"QuizzItem_question__rhBoa"};